 import { DEFAULT_LOCALE } from './locales';
 import enTranslationMessages from './dict/en.json';
 import koTranslationMessages from './dict/ko.json';
 import * as Paragraph from './paragraph';
 
 // addLocaleData(enLocaleData);
 // addLocaleData(deLocaleData);
 
 export const formatTranslationMessages = (locale, messages) => {
   const defaultFormattedMessages =
     locale !== DEFAULT_LOCALE
       ? formatTranslationMessages(DEFAULT_LOCALE, enTranslationMessages)
       : {};
   const flattenFormattedMessages = (formattedMessages, key) => {
     const formattedMessage =
       !messages[key] && locale !== DEFAULT_LOCALE
         ? defaultFormattedMessages[key]
         : messages[key];
     return { ...formattedMessages, [key]: formattedMessage };
   };
   return Object.keys(messages).reduce(flattenFormattedMessages, {});
 };

 const mergeParagraph = (message)=>{
    return {
        ...message,
        ...Paragraph
    }
 }

 export const translationMessages = {
   en: formatTranslationMessages('en', mergeParagraph(enTranslationMessages) ),
   ko: formatTranslationMessages('ko', mergeParagraph(koTranslationMessages) ),
 };
 